import { TypographyOptions } from "@mui/material/styles/createTypography";

// Cairo is the brand font (already used app-wide, Arabic-friendly). The scale
// below replaces the previous ad hoc per-usage fontSize overrides (e.g.
// PageTitle hardcoding fontSize="3rem") with one consistent set of sizes.
export const typography: TypographyOptions = {
  fontFamily: ["Cairo", "system-ui", "sans-serif"].join(","),
  h1: { fontSize: "2.25rem", fontWeight: 700, lineHeight: 1.25 },
  h2: { fontSize: "1.875rem", fontWeight: 700, lineHeight: 1.3 },
  h3: { fontSize: "1.5rem", fontWeight: 700, lineHeight: 1.35 },
  h4: { fontSize: "1.25rem", fontWeight: 600, lineHeight: 1.4 },
  h5: { fontSize: "1.125rem", fontWeight: 600, lineHeight: 1.4 },
  h6: { fontSize: "1rem", fontWeight: 600, lineHeight: 1.45 },
  subtitle1: { fontSize: "0.9375rem", fontWeight: 600 },
  subtitle2: { fontSize: "0.875rem", fontWeight: 600 },
  body1: { fontSize: "0.9375rem", fontWeight: 400, lineHeight: 1.6 },
  body2: { fontSize: "0.875rem", fontWeight: 400, lineHeight: 1.6 },
  button: { fontSize: "0.875rem", fontWeight: 600, textTransform: "none" },
  caption: { fontSize: "0.75rem", fontWeight: 400 },
};
